import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const profileSettingsSchema = z.object({
  schoolName: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.schoolName.required)
    .min(2, VALIDATION_MESSAGES.schoolName.min)
    .max(100, VALIDATION_MESSAGES.schoolName.max),

  primaryContact: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.mobileNumber.required),
  primaryContactCode: z.string().optional(),

  email: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.schoolEmail.required)
    .refine(
      (val) =>
        /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
          val
        ),
      { message: VALIDATION_MESSAGES.schoolEmail.invalid }
    ),

  phone: z.string().trim().min(1, VALIDATION_MESSAGES.mobileNumber.required),
  countryCode: z.string().optional(),
});

export type TProfileSettingsForm = z.infer<typeof profileSettingsSchema>;
